import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../_services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class IsLoggedInGuard  {

constructor(private auth: AuthService, private router: Router) { }

async canActivate(): Promise<boolean> {
  if(await this.auth.loggedIn()) {
    this.router.navigate(['']);
    return new Promise<boolean>((resolve, reject) => {
      resolve(false);
    });
  }
  return new Promise<boolean>((resolve, reject) => {
    resolve(true);
  });
}

}
@Injectable({
  providedIn: 'root'
})
export class IsntLoggedInGuard  {

constructor(private auth: AuthService, private router: Router) { }

async canActivate(): Promise<boolean> {
  if(!(await this.auth.loggedIn())) {
    this.router.navigate(['']);
    return new Promise<boolean>((resolve, reject) => {
      resolve(false);
    });
  }
  return new Promise<boolean>((resolve, reject) => {
    resolve(true);
  });
}

}

